import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Waveform, EnvelopeSimple } from "@phosphor-icons/react";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [resetUrl, setResetUrl] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      if (data.reset_url) {
        setResetUrl(data.reset_url);
        toast.success("Lien de réinitialisation généré !");
      } else {
        toast.success("Si un compte existe, un lien a été envoyé.");
      }
    } catch (err) {
      toast.error("Erreur. Réessayez.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-10 justify-center">
          <Waveform weight="fill" size={28} className="text-[#E11D48]" />
          <span className="font-display font-black text-2xl">XooKmédia</span>
        </Link>

        <div className="bg-[#0f0f10] border border-white/10 rounded-2xl p-8">
          <div className="w-12 h-12 rounded-xl bg-[#E11D48]/15 flex items-center justify-center mb-5">
            <EnvelopeSimple weight="duotone" size={26} className="text-[#E11D48]" />
          </div>
          <h1 className="font-display font-black text-3xl mb-2">Mot de passe oublié ?</h1>
          <p className="text-zinc-400 text-sm mb-8">Entrez votre email, nous générerons un lien sécurisé pour le réinitialiser.</p>

          {!resetUrl && (
            <form onSubmit={submit} className="space-y-5">
              <div>
                <Label htmlFor="email" className="text-zinc-300">Email</Label>
                <Input data-testid="forgot-email" id="email" type="email" required value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-2 bg-black/40 border-white/10 text-white" />
              </div>
              <Button data-testid="forgot-submit" type="submit" disabled={loading}
                className="w-full bg-[#E11D48] hover:bg-[#BE123C] text-white">
                {loading ? "Génération..." : "Recevoir le lien"}
              </Button>
            </form>
          )}

          {resetUrl && (
            <div className="space-y-4">
              <div className="p-4 rounded-lg bg-black/40 border border-[#10B981]/30">
                <div className="text-xs uppercase tracking-widest text-[#10B981] font-bold mb-2">Lien généré</div>
                <p className="text-zinc-300 text-sm mb-3">En production, ce lien sera envoyé par email. Pour l'instant, cliquez :</p>
                <Link to={resetUrl.replace(window.location.origin, "")}
                  data-testid="forgot-reset-link"
                  className="block break-all text-xs font-mono text-[#F59E0B] hover:text-white p-2 rounded bg-black/40">
                  {resetUrl}
                </Link>
              </div>
              <Button data-testid="forgot-continue" className="w-full bg-[#E11D48] hover:bg-[#BE123C]" asChild>
                <Link to={resetUrl.replace(window.location.origin, "")}>Continuer la réinitialisation</Link>
              </Button>
            </div>
          )}

          <p className="mt-6 text-center text-sm text-zinc-400">
            <Link to="/login" className="text-[#E11D48] hover:text-[#F59E0B]" data-testid="forgot-back-login">← Retour à la connexion</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
